import { PayloadAction } from '@reduxjs/toolkit';

type AddChatTokenAction = PayloadAction<string, 'chat/add-token'>;

type RemoveChatTokenAction = PayloadAction<undefined, 'chat/remove-token'>;

export type ChatTokenActions = AddChatTokenAction | RemoveChatTokenAction;

function addChatToken(token: string): AddChatTokenAction {
	return {
		type: 'chat/add-token',
		payload: token
	};
}

function removeChatToken(): RemoveChatTokenAction {
	return {
		type: 'chat/remove-token',
		payload: undefined
	};
}

const chatTokenActions = {
	addChatToken,
	removeChatToken
};

export default chatTokenActions;
